import {
  JSON_PARSE_RAW_LOG_SOURCE_WHITELIST,
  LOG_LEVEL,
} from '#shared/constant/log'
import { NewRelicLogHelper } from '#shared/utils/newRelicLogHelper'

/**
 * JSON.parse をラップし、パース失敗時は例外をスローせず null を返す。
 * 責務：文字列をパースしてそのまま返す（成功時は any、失敗時は null）
 * JSON.parse は any を返すため、責務に従いこの関数の成功時戻り値も any 型とする。
 * undefined 入力（例: 空配列の先頭要素アクセス）もパース失敗として扱い、ログを出して null を返す。
 */
// JSON.parse の戻り値が any のため型エイリアスとして切り出す
// （関数シグネチャ行に置くと prettier の折返しで disable コメントが any の行を覆えなくなるため）
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ParsedJson = any

export const jsonParse = (
  raw: string | undefined,
  source: string
): ParsedJson | null => {
  try {
    if (raw === undefined) {
      throw new Error('input is undefined')
    }
    return JSON.parse(raw)
  } catch (e) {
    // TypeScriptでは e の型は自動的に unknown になる
    // Error オブジェクトではない場合（文字列や数値、オブジェクトなど）も、情報を文字列化して新しい Error に閉じ込める
    const error =
      e instanceof Error
        ? e
        : new Error(
            `JSON parse failed: ${typeof e === 'object' ? JSON.stringify(e) : String(e)}`
          )

    const shouldLogRaw = JSON_PARSE_RAW_LOG_SOURCE_WHITELIST.has(source)

    NewRelicLogHelper({
      level: LOG_LEVEL.WARN,
      category: 'json-parse',
      message: 'JSON parse failed',
      error,
      detail: {
        source,
        errorMessage: error.message,
        ...(shouldLogRaw ? { raw } : {}),
      },
    })

    return null
  }
}
